import React from "react"

const BulletPointNew = () => {
  return (
    <>
      <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.65137 0.5C6.54039 0.5 7.42744 0.741075 8.2168 1.2002L19.9258 8.00879L20.0137 8.05957C21.5722 9.00658 22.5 10.654 22.5 12.498C22.5 14.3768 21.5378 16.0535 19.9258 16.9912L8.2168 23.7998H8.21582C7.4291 24.2584 6.54056 24.5 5.65137 24.5C2.81533 24.4999 0.500021 22.1751 0.5 19.3086V5.69141C0.500021 2.82673 2.81351 0.500098 5.65137 0.5Z" stroke="#6D3ADF"/>
</svg>


    </>
  )
}

export default BulletPointNew
